import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { provideAnimations } from '@angular/platform-browser/animations';
import { Router, provideRouter, withInMemoryScrolling, InMemoryScrollingOptions } from '@angular/router';
import { routes } from './app/app.routes';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './app/constants/interceptor';

// Define the scroll configuration
const scrollConfig: InMemoryScrollingOptions = {
  scrollPositionRestoration: 'top',
  anchorScrolling: 'enabled',
};

// Bootstrap the Angular application with the provided configurations
bootstrapApplication(AppComponent, {
  providers: [
    ...(appConfig.providers || []), // Include existing providers from appConfig
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
      deps: [Router],
    },
    provideRouter(routes, withInMemoryScrolling(scrollConfig)), // Provide routing and scrolling configuration
    provideAnimations(), // Provide required animations providers
   
  ],
}).catch((err) => console.error(err));
